import React from "react";
import { Row, Col, Input, Table } from "antd";
import { UserOutlined, RightOutlined, DownOutlined } from "@ant-design/icons";
import Retrieve from "../../../assets/images/retrieve.png";
import Cancel from "../../../assets/images/discard.png";
import DownloadIcon from "../../../assets/images/downloadIcon.png";
import data from "../../../constants/retailPos.json";

const parkedBillColumns = [
  {
    title: "Parked Sale",
    dataIndex: "parkedTime",
    key: "parkedTime",
    width: "30%",
  },
  {
    title: "Customer",
    dataIndex: "customer",
    key: "customer",
    width: "28%",
  },
  {
    title: "Qty",
    dataIndex: "qty",
    key: "qty",
    width: "38%",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: "19%",
  },
];

const ParkedBillsView = ({
  filterdParkedList,
  parkedBillSearchInput,
  handleParkedBillSearchInput,
  searchParkedBill,
  selectedKeys,
  retrieveParkedData,
  discardParkedBill,
  handleExpand,
  setKeyValue,
}) => {
  return (
    <div style={{ width: "100%" }}>
      <Row style={{ width: "100%" }}>
        <Col span={24} style={{ padding: "2.3% 3.5% 0 3.5%" }}>
          <Row style={{ paddingBottom: "5vh" }}>
            <Col span={11}>
              <label style={{ color: "#000", fontSize: "1.4vw" }}>Customer</label>
              <Input
                placeholder="Search for customers"
                prefix={<UserOutlined style={{ color: "#929098", height: "2vh" }} />}
                size="large"
                allowClear={true}
                style={data.posScreenStyles.orderHistoryModal.orderHistorySearchInput1}
                onPressEnter={searchParkedBill}
                onChange={handleParkedBillSearchInput}
                value={parkedBillSearchInput}
                className="parkedCustomer"
              />
            </Col>
            <Col span={13} style={{ display: "flex", justifyContent: "end" }}>
              <span style={{ position: "absolute", bottom: 0, paddingRight: "1vw", color: "#A4CD38", fontSize: "1.1vw" }}>
                <img src={DownloadIcon} style={{ height: "1.3vw", paddingRight: "4px" }} />
                Export list
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row style={{ padding: "0% 3.5% 0 3.5%" }}>
        <Table
          style={{ height: "75vh", background: "#F3F4F9", fontSize: "0.9vw", padding: "0% 1.5% 0 1.5%", borderRadius: "5px" }}
          scroll={{ y: "68vh" }}
          pagination={false}
          columns={parkedBillColumns}
          dataSource={filterdParkedList}
          rowClassName={(record) => (selectedKeys[0] === record.key ? "tableSelectedBlue" : "tableNonSelectedWhite")}
          className="parkedTable"
          expandable={{
            expandedRowRender: (record) => (
              <div style={{ padding: "1% 4% 1% 4%", backgroundColor: "#fff" }}>
                <Row>
                  <Col span={21}>
                    <Row>
                      <Col span={12} className="td-nested-title">
                        Description
                      </Col>
                      <Col span={3} className="td-nested-title" style={{ textAlign: "center" }}>
                        Qty
                      </Col>
                      <Col span={3} offset={1} className="td-nested-title" style={{ textAlign: "center" }}>
                        Unit Price
                      </Col>
                      <Col span={3} offset={1} className="td-nested-title" style={{ textAlign: "center" }}>
                        Net Total
                      </Col>
                    </Row>
                    <Row style={{ paddingBottom: "0.5vw" }}>
                      {record.parkedCart.items.map((e, idx) => (
                        <React.Fragment key={e.lineId || e.name + idx}>
                          <Col span={12} className="td-nested-description">
                            {e.name}
                          </Col>
                          <Col span={3} style={{ textAlign: "center", fontWeight: "500" }}>
                            {e.weight}
                          </Col>
                          <Col span={1} style={{ textAlign: "center", fontWeight: "500" }} />
                          <Col span={3} style={{ textAlign: "center", fontWeight: "500" }}>
                            {e.realPrice?.toFixed(2)}
                          </Col>
                          <Col span={1} style={{ textAlign: "center" }} />
                          <Col span={3} style={{ textAlign: "right", paddingRight: "1.5vw", fontWeight: "500" }}>
                            {(e.realPrice - record.parkedCart.tax).toFixed(2)}
                          </Col>
                        </React.Fragment>
                      ))}
                    </Row>
                    <p style={{ width: "96%", marginLeft: "0%", borderTop: "1.3px solid rgba(52, 40, 44, 0.55)", marginBottom: "0px" }} />
                    <Row style={{ paddingTop: "5px" }}>
                      <Col span={3} offset={17} className="td-subtotal">
                        <span className="td-subTotalText">Subtotal</span>
                        <span className="td-subTotalText">Total tax</span>
                      </Col>
                      <Col span={3} className="td-subtotal" style={{ textAlign: "right", paddingRight: "1.5vw" }}>
                        <span className="td-subTotalText">{record.parkedCart.total?.toFixed(2) - record.parkedCart.tax?.toFixed(2)}</span>
                        <span className="td-subTotalText">{record.parkedCart.tax?.toFixed(2)}</span>
                      </Col>
                    </Row>
                    <Row style={{ marginBottom: "1%" }}>
                      <Col span={3} offset={17} className="td-subtotal" style={{ padding: "4px 0" }}>
                        <span className="td-total">SALE TOTAL</span>
                      </Col>
                      <Col
                        span={3}
                        style={{ fontSize: "1.1vw", borderBottom: "1px solid rgba(52, 40, 44, 0.55)", textAlign: "right", paddingRight: "1.5vw", paddingTop: "4px" }}
                      >
                        <span className="td-total">{record.parkedCart.total?.toFixed(2)}</span>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={3} className="td-bottons">
                    <p
                      style={{ cursor: "pointer", padding: "5.5% 12%", borderRadius: "3px", border: "1px solid #929098" }}
                      onClick={() => {
                        setKeyValue("0");
                        retrieveParkedData(record);
                      }}
                    >
                      <img src={Retrieve} style={{ height: "1vw", paddingRight: "0.2vw", cursor: "pointer" }} />
                      Retrieve sale
                    </p>
                    <p
                      style={{ cursor: "pointer", padding: "5.5% 13%", borderRadius: "3px", border: "1px solid #929098" }}
                      onClick={() => discardParkedBill(record)}
                    >
                      <img src={Cancel} style={{ height: "1.1vw", paddingRight: "0.4vw" }} />
                      Discard sale
                    </p>
                  </Col>
                </Row>
              </div>
            ),
            expandIcon: ({ expanded, onExpand, record }) => (
              <span onClick={(e) => onExpand(record, e)}>
                {expanded ? <DownOutlined style={{ color: "#929098" }} /> : <RightOutlined style={{ color: "#929098" }} />}
              </span>
            ),
          }}
          onExpand={handleExpand}
        />
      </Row>
    </div>
  );
};

export default React.memo(ParkedBillsView);
